export enum LEAD_POLICY {
  ACTIVE = 'ACTIVE',
  MINIMUM_PAYMENT = 'MINIMUM_PAYMENT',
  STOP_PAYMENT = 'STOP_PAYMENT',
  CANCEL = 'CANCEL'
}

export enum LEAD_TYPE {
  PROSPECT = 'PROSPECT',
  CUSTOMER = 'CUSTOMER',
  HIDDEN = 'HIDDEN'
}

export enum LEAD_LOG_TYPE {
  CONTACT = 'CONTACT',
  HOME = 'HOME',
  WORK = 'WORK'
}

export enum LEAD_BULK_ACTION {
  CHANGE_OWNER = 'CHANGE_OWNER',
  CHANGE_AGENT = 'CHANGE_AGENT',
  CHANGE_CSR = 'CHANGE_CSR',
  HIDE = 'HIDE',
  EXPORT = 'EXPORT'
}

export enum LeadColEnum {
  OWNER = 'owner',
  LEAD = 'lead',
  FULL_NAME = 'fullName',
  LEAD_ID = 'leadId',
  LEAD_TYPE = 'leadType',
  LEAD_STAGE = 'leadStage',
  STATUS = 'leadStatus',
  NAME = 'contactName',
  CELLPHONE = 'contactCellPhone',
  WORK_PHONE = 'contactWorkPhone',
  CELLPHONE2 = 'contactCellPhone2',
  HOME_PHONE = 'contactHomePhone',
  CONTACT_CELLPHONE = 'cellPhone',
  CONTACT_CELLPHONE2 = 'cellPhone2',
  CONTACT_WORK_PHONE = 'workPhone',
  CONTACT_HOME_PHONE = 'homePhone',
  STATE = 'state',
  SOURCE = 'leadSource',
  AGENT = 'agent',
  EMAIL = 'contactEmail',
  GENDER = 'gender',
  DATE_OF_BIRTH = 'dateOfBirth',
  MARITAL_STATUS = 'maritalStatus',
  POLICY_STATUS = 'policyStatus',
  LEAD_TAG = 'tags',
  CITY = 'city',
  USA_CITIZEN = 'isUSACitizen',
  GREEN_CARD = 'greenCardNumber',
  DRIVER_LICENSE = 'driverLicense',
  SSN_TAX_ID = 'taxId',
  CSR = 'csr',
  DATE_ADDED = 'createdAt',
  CREATED_BY = 'createdBy',
  SUB_SOURCE = 'subSource',
  PAIN_POINTS = 'painPoints',
  NEEDS = 'needs',
  ADDRESS = 'addressLine',
  MAILING_ADDRESS = 'mailingAddressLine',
  ORTHER_NAME = 'otherName',
  EMAIL_2 = 'email',
  OWNER_2 = 'currentUser',
  LAST_UPDATE = 'lastInteractionAt',
  SMS_CAMPAIGN = 'smsCampaigns'
}

export const LEAD_COL_WIDTH: Record<LeadColEnum, number> = {
  [LeadColEnum.OWNER]: 230,
  [LeadColEnum.OWNER_2]: 230,
  [LeadColEnum.LEAD]: 270,
  [LeadColEnum.FULL_NAME]: 270,
  [LeadColEnum.LEAD_ID]: 115,
  [LeadColEnum.LEAD_TYPE]: 120,
  [LeadColEnum.LEAD_STAGE]: 120,
  [LeadColEnum.STATUS]: 127,
  [LeadColEnum.NAME]: 200,
  [LeadColEnum.ADDRESS]: 220,
  [LeadColEnum.MAILING_ADDRESS]: 220,
  [LeadColEnum.ORTHER_NAME]: 170,

  [LeadColEnum.CELLPHONE]: 175,
  [LeadColEnum.WORK_PHONE]: 186,
  [LeadColEnum.CELLPHONE2]: 160,
  [LeadColEnum.HOME_PHONE]: 170,
  [LeadColEnum.CONTACT_CELLPHONE]: 160,
  [LeadColEnum.CONTACT_CELLPHONE2]: 160,
  [LeadColEnum.CONTACT_WORK_PHONE]: 170,
  [LeadColEnum.CONTACT_HOME_PHONE]: 170,

  [LeadColEnum.STATE]: 130,
  [LeadColEnum.SOURCE]: 160,
  [LeadColEnum.AGENT]: 160,
  [LeadColEnum.EMAIL]: 220,
  [LeadColEnum.EMAIL_2]: 220,

  [LeadColEnum.GENDER]: 120,
  [LeadColEnum.DATE_OF_BIRTH]: 160,
  [LeadColEnum.MARITAL_STATUS]: 140,
  [LeadColEnum.LAST_UPDATE]: 160,

  [LeadColEnum.POLICY_STATUS]: 140,
  [LeadColEnum.LEAD_TAG]: 180,
  [LeadColEnum.SMS_CAMPAIGN]: 180,

  [LeadColEnum.CITY]: 140,
  [LeadColEnum.USA_CITIZEN]: 130,
  [LeadColEnum.GREEN_CARD]: 160,
  [LeadColEnum.DRIVER_LICENSE]: 180,
  [LeadColEnum.SSN_TAX_ID]: 150,

  [LeadColEnum.CSR]: 140,
  [LeadColEnum.DATE_ADDED]: 160,
  [LeadColEnum.CREATED_BY]: 120,

  [LeadColEnum.SUB_SOURCE]: 160,
  [LeadColEnum.PAIN_POINTS]: 200,
  [LeadColEnum.NEEDS]: 200
};

export enum LeadExcelDataKey {
  ADDRESS = 'ADDRESS',
  AGENT = 'AGENT_(*)',
  AVATAR = 'AVATAR',
  CELLPHONE = 'CELLPHONE',
  CELLPHONE2 = 'CELLPHONE2',
  HOMEPHONE = 'HOME PHONE',
  CITY = 'CITY',
  CONTACT_CELLPHONE = 'CONTACT CELLPHONE_(*)',
  CONTACT_CELLPHONE2 = 'CONTACT CELLPHONE2',
  CONTACT_HOME_PHONE = 'CONTACT HOME PHONE',
  CONTACT_EMAIL = 'CONTACT EMAIL',
  CONTACT_NAME = 'CONTACT NAME_(*)',
  CONTACT_WORK_PHONE = 'CONTACT WORK PHONE',
  CREATED_BY = 'CREATED BY',
  CSR = 'CSR',
  DATE_OF_BIRTH = 'DATE OF BIRTH',
  DRIVER_LICENSE = 'DRIVER LICENSE',
  EMAIL = 'EMAIL',
  FULL_NAME = 'FULL NAME_(*)',
  GENDER = 'GENDER',
  GREEN_CARD_NUMBER = 'GREEN CARD NUMBER',
  LEAD_STAGE = 'LEAD STAGE_(*)',
  LEAD_STATUS = 'LEAD STATUS_(*)',
  LEAD_TAG = 'LEAD TAG',
  SMS_CAMPAIGN = 'SMS CAMPAIGN',
  LEAD_TYPE = 'LEAD TYPE',
  MAILING_ADDRESS = 'MAILING ADDRESS',
  MAILING_CITY = 'MAILING CITY',
  MAILING_STATE_PROVINCE = 'MAILING STATE/PROVINCE',
  MAILING_ZIP_CODE = 'MAILING ZIP CODE',
  MARITAL_STATUS = 'MARITAL STATUS',
  OTHER_NAME = 'OTHER NAME',
  OWNER = 'OWNER_(*)',
  POLICY_STATUS = 'POLICY STATUS',
  SOURCE = 'SOURCE_(*)',
  STATE_PROVINCE = 'STATE/PROVINCE',
  SUB_SOURCE = 'SUB SOURCE_(*)',
  USA_CITIZEN = 'USA CITIZEN',
  WORK_PHONE = 'WORK PHONE',
  ZIP_CODE = 'ZIP CODE',
  SSN_TAX_ID = 'SSN/TAX ID'
}
